module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "keyboard bt"
  }, [_c('div', {
    staticClass: "bb ovf"
  }, [_c('div', {
    staticClass: "board-btn br"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick(1)
      }
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
    staticClass: "board-btn br"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick(2)
      }
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    staticClass: "board-btn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick(3)
      }
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
    staticClass: "bb ovf"
  }, [_c('div', {
    staticClass: "board-btn br"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick(4)
      }
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    staticClass: "board-btn br"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick(5)
      }
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('div', {
    staticClass: "board-btn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick(6)
      }
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "bb ovf"
  }, [_c('div', {
    staticClass: "board-btn br"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick(7)
      }
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('div', {
    staticClass: "board-btn br"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick(8)
      }
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('div', {
    staticClass: "board-btn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick(9)
      }
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('div', {
    staticClass: "bb ovf"
  }, [_c('div', {
    staticClass: "board-btn br"
  }, [(_vm.mode == 'int') ? _c('button', {
    staticClass: "none",
    attrs: {
      "type": "button"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode == 'float') ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick('.')
      }
    }
  }, [_vm._v("\n        .\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "board-btn br"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick(0)
      }
    }
  }, [_vm._v("0")])]), _vm._v(" "), _c('div', {
    staticClass: "board-btn"
  }, [_c('button', {
    staticClass: "del",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleClick('del')
      }
    }
  }, [_vm._v("Del")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46c5c055!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keyboard/keyboard.vue
// module id = 245
// module chunks = 29